export const ExternalImages = {
    AutodialogLogo: "/logo_vertical.svg"
};